export const InputBorderDefault = "0.5px solid #d9d9d9";

export const InputBorderInvalid = "0.5px solid red";
